import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import logo from "../logo-vpvv.png";
import "./Iceremony.css";

const Iceremony = () => {
  const [lgShow, setLgShow] = useState(true);
  const [numGuests, setNumGuests] = useState(1);
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setGuests(
      Array.from({ length: numGuests }, () => ({
        name: "",
        age: "",
        contact: "",
        designation: "",
        aadharFront: null,
        aadharBack: null,
      }))
    );
  }, [numGuests]);

  const handleInputChange = (index, e) => {
    const { name, value, files } = e.target;
    setGuests((prev) =>
      prev.map((guest, i) =>
        i === index ? { ...guest, [name]: files ? files[0] : value } : guest
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const formData = new FormData();
    formData.append("Peoples", numGuests);  // Match backend expectation
    formData.append("Company", "your_company_id"); // Replace with actual company ID
  
    guests.forEach((guest, index) => {
      formData.append("Name[]", guest.name);
      formData.append("Age[]", guest.age);
      formData.append("Designation[]", guest.designation);
      formData.append("Contact[]", guest.contact);
      if (guest.aadharFront) formData.append(`frontAadhar[${index}]`, guest.aadharFront);
      if (guest.aadharBack) formData.append(`backAadhar[${index}]`, guest.aadharBack);
    });
  
    try {
      const response = await axios.post(
        "http://localhost:4001/api/v1/addicguest",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("Success:", response.data);
      navigate("/IcBodyMeasurementDetails", { state: { numGuests } });
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <Modal size="lg" show={lgShow} onHide={() => setLgShow(false)} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Read All The Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please read all instructions carefully before proceeding.</Modal.Body>
      </Modal>

      <div className="ic-container">
        <img src={logo} alt="logo" style={{ width: "150px" }} />
        <h2 style={{ color: "white" }}>VPVV TECHNO CONSTRUCTION PRIVATE LIMITED</h2>
        <h4>Select The Number of Guests & Fill Up The Form</h4>

        <Form.Select value={numGuests} onChange={(e) => setNumGuests(parseInt(e.target.value))} className="select">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </Form.Select>

        <div className="ic-form">
          <h2 className="form-title">Contact Details</h2>
          <Form onSubmit={handleSubmit}>
            {guests.map((guest, index) => (
              <div key={index}>
                <h5 className="guestSeries">Guest {index + 1}</h5>
                <Row className="mb-3">
                  <Form.Group as={Col}>
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" name="name" placeholder="Enter name" value={guest.name} onChange={(e) => handleInputChange(index, e)} required />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col}>
                    <Form.Label>Age</Form.Label>
                    <Form.Control type="number" name="age" placeholder="Age" value={guest.age} onChange={(e) => handleInputChange(index, e)} required />
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>Contact</Form.Label>
                    <Form.Control type="number" name="contact" placeholder="Contact no." value={guest.contact} onChange={(e) => handleInputChange(index, e)} required />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col}>
                    <Form.Label>Upload Aadhar (Front)</Form.Label>
                    <Form.Control type="file" name="aadharFront" onChange={(e) => handleInputChange(index, e)} required />
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label>Upload Aadhar (Back)</Form.Label>
                    <Form.Control type="file" name="aadharBack" onChange={(e) => handleInputChange(index, e)} required />
                  </Form.Group>
                </Row>
                <Form.Label>Designation</Form.Label>
                <Form.Select aria-label="Default select example" required>
                  <option>Select...</option>
                  <option value="Director">Director</option>
                  <option value="Nominee">Nominee</option>
                  <option value="CEO">CEO</option>
                  <option value="CFO">CFO</option>
                </Form.Select>  
              </div>
            ))}


            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Iceremony;